<template>
  <span class="animated-counter text-weight-bolder q-mx-xs" :style="counterStyle">{{ targetNumber === undefined ? '---' : formattedNumber }}</span>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch, computed } from 'vue'

const props = defineProps<{
  targetNumber: number
  duration?: number
}>()

const displayNumber = ref(0)

const counterStyle = computed(() => ({
  display: 'inline-block',
  color: '#AD1900 !important',
  'fontFamily': 'tahoma, ui-monospace',
  width: `${props.targetNumber.toString().length}ch`
}))

const formattedNumber = computed(() => {
  const targetDigits = props.targetNumber.toString().length
  return displayNumber.value.toString().padStart(targetDigits, '0')
})

const animateValue = () => {
  const start = 0
  const end = props.targetNumber
  const duration = props.duration || 1000
  const startTime = performance.now()

  const updateNumber = (currentTime: number) => {
    const elapsed = currentTime - startTime
    const progress = Math.min(elapsed / duration, 1)

    displayNumber.value = Math.round(start + (end - start) * progress)

    if (progress < 1) {
      requestAnimationFrame(updateNumber)
    }
  }

  requestAnimationFrame(updateNumber)
}

onMounted(() => {
  setTimeout(() => {
    animateValue()
  },2000)
})

watch(() => props.targetNumber, () => {
  animateValue()
})
</script>
